import { Platform } from 'react-native';
import { useResponsiveLayout } from './useResponsiveLayout';

/**
 * True only when the enterprise desktop shell (sidebar nav, docked panels,
 * dialog-style sheets) should render: wide-viewport WEB. Native never enters
 * the shell — an iPad Pro in landscape is >1024pt wide, and flipping native
 * into desktop chrome would invalidate the Maestro suite and gorhom sheet
 * behavior. Always branch on this hook, never on raw `isDesktop`.
 */
export function useDesktopShell(): boolean {
  const { isDesktop } = useResponsiveLayout();
  return Platform.OS === 'web' && isDesktop;
}
